import { Building2, CalendarDays, Presentation, CircleHelp, Dumbbell, LayoutTemplate, UserRound, UsersRound, type LucideIcon } from 'lucide-react';

/** The main menu, built from this list. Later items (drills, sessions, planner) slot in here. */
export interface NavItem {
  label: string;
  to: string;
  icon: LucideIcon;
  /** Match child routes too (e.g. /teams/123 lights up Teams). */
  match?: (path: string) => boolean;
  /** Coach-only items are hidden from people who are only players, parents or read-only members. */
  coachOnly?: boolean;
  /** For people who help run a club, and coaches (who can register one). Not players and parents. */
  clubOnly?: boolean;
}

export const NAV: NavItem[] = [
  { label: 'Schedule', to: '/', icon: CalendarDays, match: (p) => p === '/' || /^\/teams\/[^/]+\/sessions\//.test(p) },
  { label: 'Drills', to: '/drills', icon: Dumbbell, match: (p) => p.startsWith('/drills'), coachOnly: true },
  { label: 'Templates', to: '/templates', icon: LayoutTemplate, match: (p) => p.startsWith('/templates'), coachOnly: true },
  { label: 'Teams', to: '/teams', icon: UsersRound, match: (p) => p.startsWith('/teams') && !/^\/teams\/[^/]+\/sessions\//.test(p) },
  { label: 'Club', to: '/clubs', icon: Building2, match: (p) => p.startsWith('/clubs'), clubOnly: true },
  { label: 'Game day', to: '/gameday', icon: Presentation, coachOnly: true },
  { label: 'Help', to: '/help', icon: CircleHelp, match: (p) => p.startsWith('/help') },
  { label: 'Account', to: '/account', icon: UserRound, match: (p) => p.startsWith('/account') },
];
